import { useMemo } from 'react'
import {
  selectAllEntityAppointments,
  useGetEntityAppointmentsOnMount,
} from '@user/store/scheduling'
import { filterByEntity } from '@sales-center/common'
import { useAppSelector } from '@user/store/hooks'
import type { AppointmentsProps } from './Appointments'

export function useData(props: AppointmentsProps) {
  const { entityId, entityType } = props

  const status = useGetEntityAppointmentsOnMount(entityId, entityType)

  const allAppts = useAppSelector(selectAllEntityAppointments)

  const appointments = useMemo(
    () =>
      filterByEntity(allAppts, entityId, entityType).filter(
        (a) => a.status !== 'Cancelled',
      ),
    [allAppts, entityId, entityType],
  )

  return { status, appointments }
}
